import React, { useState } from "react";
import {
  Button,
  Typography,
  Grid,
  InputBase,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import {
  fonts,
  headingFonts,
  inputBaseStyles,
  mainButtonStyles,
} from "../../Styles/Styles";

const CTA = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info"); // "success" or "error"
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleEmailSubmit = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      setSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/contact/subscribe`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to subscribe. Please try again.");
      }

      setMessage("Subscribed successfully!");
      setSeverity("success");
      setEmail(""); // Clear input on success
    } catch (error) {
      console.error("Subscription error:", error);
      setMessage(error.message || "Something went wrong. Please try again.");
      setSeverity("error");
    } finally {
      setOpenSnackbar(true);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "50vh",
        padding: "20px",
        backgroundImage: "url(/Images/BG-Lines-Listed.png)",
        backgroundSize: "cover",
      }}
    >
      <Typography variant="h4" gutterBottom sx={{ zIndex: 1, ...headingFonts }}>
        Stay in the Loop with Exclusive Updates!
      </Typography>
      <Typography variant="body1" paragraph sx={{ zIndex: 1, ...fonts }}>
        Subscribe now to receive the latest news and special offers in your
        inbox.
      </Typography>

      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ zIndex: 1 }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <InputBase
            fullWidth
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            startAdornment={
              <AlternateEmailOutlinedIcon
                sx={{ color: "var(--primary-color)", marginRight: "8px" }}
              />
            }
            sx={{ ...inputBaseStyles }}
          />
        </Grid>

        <Grid item>
          <Button
            onClick={handleEmailSubmit}
            className="main-button-style"
            sx={{ ...mainButtonStyles, padding: "15px 25px" }}
          >
            <span>Subscribe</span>
            <span>
              <ArrowForwardOutlinedIcon />
            </span>
          </Button>
        </Grid>
      </Grid>

      {/* Snackbar for messages */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CTA;
